var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.607 30V102.679H261.536C250.49 102.679 241.536 111.633 241.536 122.679V175.357H319.214L299.393 248.036H241.536V400H168.857L168.857 248.036H111V175.357H168.857L168.857 100C168.857 61.3401 200.197 30 238.857 30H312.607Z",
    fill: "#4BB3FD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.857 400V248.036H168.857L168.857 400H203.857Z",
    fill: "#4BB3FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146 248.036V175.357H111V248.036H146Z",
    fill: "#4BB3FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.857 175.357H203.857L203.857 100C203.857 61.3401 235.197 30 273.857 30H238.857C200.197 30 168.857 61.3401 168.857 100L168.857 175.357Z",
    fill: "#4BB3FD"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312.607 30V102.679H261.536C250.49 102.679 241.536 111.633 241.536 122.679V175.357H319.214L299.393 248.036H241.536V400H168.857L168.857 248.036H111V175.357H168.857L168.857 100C168.857 61.3401 200.197 30 238.857 30H312.607Z",
    stroke: "#121331",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4dfa1cb6c76432c43cab7eb8f75593c7.svg";
export { ForwardRef as ReactComponent };